/**
 * <summary>
 * formik form to upload or update Headquarter product & treatment icons.
 * button label changes based on icon presence.
 * </summary>
 */
import { Form, Formik, Field } from "formik";
import { Col, Row } from "react-bootstrap";
import Label from "../../../shared-components/label/label";
import LoaderButton from "../../../shared-components/button/loader-button";
import { IHeadquarterVM } from "../../../models/response/IHeadquarterResponse";
import FormikFormUploadImages from "../../../shared-components/FormikFormHandlers/FormikFormUploadImages";
import { observer } from "mobx-react";
import { IObservableInitialState } from "../../../models/ICommon";
import { useState, useRef, useEffect } from "react";
interface IProps {
  id: number;
  submitHandler: (data: IHeadquarterVM) => void;
  loading: boolean;
  initialValues: any;
  isUpdateMode: boolean;
  disableAction: boolean;
  addUpdateHeadquarterUploadIconsState: IObservableInitialState;
}

const AddEditUploadIconsForm = (props: IProps) => {
  const [resetFormValues, setResetFormValues] = useState<(() => void) | null>(null);

  const hasReset = useRef(false);

  useEffect(() => {
    if (props.addUpdateHeadquarterUploadIconsState.success && resetFormValues && !hasReset.current) {
      resetFormValues();
      hasReset.current = true; // prevent further resets
    } else if (!props.addUpdateHeadquarterUploadIconsState.success) {
      hasReset.current = false; // allow reset again on next success
    }
  }, [props.addUpdateHeadquarterUploadIconsState.success, resetFormValues]);
  
  return (
    <Formik
      initialValues={props.initialValues}
      enableReinitialize
      validateOnBlur={false}
      onSubmit={async (values, { resetForm }) => {
        setResetFormValues(() => resetForm);
        props.submitHandler(values);
      }}
    >
      {({ values }) => (
        <Form className="setting-form" noValidate>
          <Row className="position-relative">
            {/* Treatment Icon Upload */}
            <Col sm={6} className="mb-3">
              <Label
                className="label-style d-block pb-0"
                required={false}
                label="treatment_icon"
              />
              <Field
                className="form-control"
                name="TreatmentIcon"
                type="text"
                as={FormikFormUploadImages}
              />
            </Col>

            {/* Product Icon Upload */}
            <Col sm={6} className="mb-3">
              <Label
                className="label-style d-block pb-0"
                required={false}
                label="product_icon"
              />
              <Field
                className="form-control"
                name="ProductIcon"
                type="text"
                as={FormikFormUploadImages}
              />
            </Col>
            <Col xs={12} md={12}>
              <LoaderButton
                type="submit"
                className="mt-3"
                isLoading={props.loading}
                disabled={
                  ((values.TreatmentIcon == null ||
                    values.TreatmentIcon == "") &&
                  (values.ProductIcon == null || values.ProductIcon == "") &&
                  !(
                    props.initialValues?.ProductIcon ||
                    props.initialValues?.TreatmentIcon
                  )
                    ? true
                    : false) || props.disableAction
                }
                text={
                  props.initialValues?.ProductIcon ||
                  props.initialValues?.TreatmentIcon
                    ? "button_update"
                    : "button_save"
                }
              />
            </Col>
          </Row>
        </Form>
      )}
    </Formik>
  );
};

export default observer(AddEditUploadIconsForm);
